import { CommonResultId } from '../common/CommonResultId.js'
import { EventStatusId } from '../EventStatusId.js'
import { ResultId } from '../ResultId.js'
import { Basketball3x3ResultId } from './Basketball3x3ResultId.js'
import { Basketball3x3EventStatusId } from './EventStatusId.js'

export const basketball3x3StatusResultsMap: {
  [key in EventStatusId]?: ResultId[]
} = {
  [Basketball3x3EventStatusId.RegularTime]: [
    CommonResultId.Result,
    CommonResultId.RegularTime,
    Basketball3x3ResultId.RegularTime,
  ],
}
